export default __webpack_public_path__ + "static/2_29-f5c5195aab8306c12e9f312eebee9493.png";